import styled, { css } from "styled-components"
import { buttonStyles, largeButtonStyles } from "../button/button.styled"
import { smallBodyTextStyles } from "../../../components/common/general-styles.component"
import React from "react"
import { AppLink } from "./base-link.component"

export const BaseLink = styled((props) => <AppLink {...props} />)``

export const BasicButtonLink = styled(BaseLink)`
  ${buttonStyles};
  text-decoration: none;
  border: 1px solid ${({ theme }) => theme.color.button};
`

export const InvertedButtonLink = styled(BasicButtonLink)`
  border: 1px solid ${({ theme }) => theme.color.invertedButtonColor};
  background: transparent;
  color: ${({ theme }) => theme.color.invertedButtonColor};
`

export const LargeButtonLink = styled(BasicButtonLink)`
  ${largeButtonStyles};
`

export const DisabledButtonLink = styled(BasicButtonLink)`
  pointer-events: none;
  background-color: ${({ theme }) => theme.color.placeholder};
  border: 1px solid ${({ theme }) => theme.color.placeholder};
  color: ${({ theme }) => theme.color.placeholder};
  cursor: not-allowed;
`

export const rawLinkStyles = css`
  color: ${({ theme }) => theme.color.link};
  text-decoration: none;
  transition: color 0.15s ease-in-out;
  font-weight: 400;

  &:hover {
    color: ${({ theme }) => theme.color.linkHover};
  }

  &.active,
  &.active:hover {
    color: ${({ theme }) => theme.color.linkHover};
  }
`

export const RawLink = styled(BaseLink)`
  ${rawLinkStyles};
`

export const NeutralRawLink = styled(RawLink)`
  color: inherit;
`

// It has impact only with Facto font
export const NeutralBoldRawLink = styled(NeutralRawLink)`
  font-weight: 500;
`

export const TextLink = styled(RawLink)`
  ${smallBodyTextStyles};
  color: ${({ theme }) => theme.color.link};
`

export const UpperscoredTextLink = styled(TextLink)`
  color: ${({ theme }) => theme.color.link};

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    position: absolute;
    bottom: 0;
  }
`

export const NeutralTextLink = styled(TextLink)`
  color: inherit;
`
